export default "__VITE_ASSET__ONo518q1__"